import { OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl } from '@angular/forms';
import { searchManyInputStyles } from '@core/components/fc-input/base/fc-search-many-input/fc-search-many-input.component';
import { INTERVAL } from '@core/consts';
import { clearEmptyProperties, mapCheckbox, mapIds } from '@core/utils/filters-utils';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';
import english from '../i18n/en.json';
import spanish from '../i18n/es.json';
import portuguese from '../i18n/pt.json';
var FilterRecurrencesComponent = /** @class */ (function () {
    function FilterRecurrencesComponent(formBuilder, fuseTranslationLoaderService) {
        this.formBuilder = formBuilder;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.intervals = INTERVAL;
        this.filterChanged = new BehaviorSubject({ archived: false });
        this.desiredStyle = searchManyInputStyles.Outlined;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    FilterRecurrencesComponent.prototype.ngOnInit = function () {
        var _this = this;
        var intervals = this.intervals.map(function () { return new FormControl(false); });
        this.filtersForm = this.formBuilder.group({
            intervalIn: new FormArray(intervals),
            segmentId: new FormControl(),
            companyId: new FormControl(),
            locations: new FormControl(),
            maintenanceTypeId: new FormControl(),
            archived: new FormControl(false),
        });
        this.filtersForm.valueChanges.pipe(debounceTime(500), tap(function () {
            var filters = clearEmptyProperties({
                interval_in: mapCheckbox(_this.filtersForm.value.intervalIn, _this.intervals, 'value'),
                segmentId_in: _this.filtersForm.value.segmentId,
                locationId_in: mapIds(_this.filtersForm.value.locations),
                maintenanceTypeId_in: _this.filtersForm.value.maintenanceTypeId,
                companyId_in: _this.filtersForm.value.companyId,
                archived: _this.filtersForm.value.archived
            });
            _this.filterChanged.next(filters);
        })).subscribe();
    };
    FilterRecurrencesComponent.prototype.clearFilters = function () {
        this.filtersForm.patchValue({
            intervalIn: this.intervals.map(function () { return false; }),
            segmentId: null,
            locations: null,
            maintenanceTypeId: null,
            companyId: null,
            archived: false,
        });
    };
    return FilterRecurrencesComponent;
}());
export { FilterRecurrencesComponent };
